import { faFileText } from '@fortawesome/free-regular-svg-icons';
import { useCallback } from 'react';

import { Button } from 'apps/shared/scripts/components';
import { useDownloadInvoice } from 'apps/shared/scripts/graphql';
import { formatInvoiceNumber } from 'apps/shared/scripts/utils';

import {
  buttonClassName,
  headingClassName,
  invoiceHeaderClassName,
} from './styles';

interface Props {
  id: string;
  invoiceNumber: number;
}

const InvoiceHeader = ({ id, invoiceNumber }: Props) => {
  const { mutate: downloadInvoice, isMutating: loading } = useDownloadInvoice();

  const onDownload = useCallback(async () => {
    try {
      const { result } = await downloadInvoice({ id });
      if (!result) {
        throw new Error('No PDF found');
      }
      const link = document.createElement('a');
      link.href = result.url;
      link.setAttribute('download', `invoice.pdf`);
      document.body.appendChild(link);
      link.click();
      link.parentNode?.removeChild(link);
    } catch (e) {
      if (e instanceof Error) {
        // todo(jgan): handle error
      }
    }
  }, [downloadInvoice, id]);

  return (
    <div className={invoiceHeaderClassName}>
      <h2 className={headingClassName}>
        Invoice {formatInvoiceNumber(invoiceNumber)}
      </h2>
      <Button
        className={buttonClassName}
        faIcon={faFileText}
        onClick={onDownload}
        loading={loading}
        disabled={loading}
      >
        Download
      </Button>
    </div>
  );
};

InvoiceHeader.displayName = 'InvoiceHeader';

export default InvoiceHeader;
